const SET_LOYALTY = 'LOYALTY/SET_LOYALTY'
const SET_TRANSACTIONS_EARNED = 'LOYALTY/SET_TRANSACTIONS_EARNED'
const SET_TRANSACTIONS_REDEEMED = 'LOYALTY/SET_TRANSACTIONS_REDEEMED'
const SET_ACTIVE_VOUCHERS = 'LOYALTY/SET_ACTIVE_VOUCHERS'
const SET_USED_VOUCHERS = 'LOYALTY/SET_USED_VOUCHERS'

// TODO: add more action types if necessary

export {
  SET_LOYALTY,
  SET_TRANSACTIONS_EARNED,
  SET_TRANSACTIONS_REDEEMED,
  SET_ACTIVE_VOUCHERS,
  SET_USED_VOUCHERS,
  // TODO: export action types added later
}
